import { render, staticRenderFns } from "./AppSideNavTemplate.vue?vue&type=template&id=82bdd5c8"
import script from "./AppSideNavTemplate.vue?vue&type=script&lang=js"
export * from "./AppSideNavTemplate.vue?vue&type=script&lang=js"
import style0 from "./AppSideNavTemplate.vue?vue&type=style&index=0&id=82bdd5c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports